import { useCallback, useMemo, useState } from 'react';

import { useCalendarContext } from '../context/CalendarContext';

import { CalendarDay } from './CalendarDay';

export const CalendarDays = () => {
  const { month, dates, mode } = useCalendarContext();
  const [date, setDate] = useState<moment.Moment | null>(null);

  const { days_previous, days_current, days_next } = useMemo(() => {
    const days = month.daysInMonth();
    const month_start = month.clone().startOf('month').day();
    const month_prev = month.clone().subtract(1, 'month');
    const month_prev_days = month_prev.daysInMonth();

    return {
      days_previous: Array.from({ length: month_start }, (_, i) => ({
        day: month_prev_days - month_start + i + 1,
        offset: -1,
      })),
      days_current: Array.from({ length: days }, (_, i) => ({
        day: i + 1,
        offset: 0,
      })),
      days_next: Array.from({ length: 42 - (month_start + days) }, (_, i) => ({
        day: i + 1,
        offset: 1,
      })),
    };
  }, [month]);

  const onMouseEnter = useCallback(
    (day: number, offset: number) => {
      if (mode === 'range' && dates.length === 1) {
        setDate(month.clone().add(offset, 'months').date(day));
      }
    },
    [mode, dates, month]
  );

  const onMouseLeave = useCallback(() => setDate(null), []);

  const days = useMemo(
    () => [...days_previous, ...days_current, ...days_next],
    [days_previous, days_current, days_next]
  );

  return (
    <>
      {days.map(({ day, offset }) => (
        <CalendarDay
          key={`${day}-${offset}`}
          day={day}
          offset={offset}
          date={date}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      ))}
    </>
  );
};
